import { useQuery } from '@tanstack/react-query'
import { Navigate, useParams } from 'react-router'
import { Spinner } from '@/components/ui/spinner'
import { eventQueryOptions } from '@/features/marquee/query-options'
import { routes } from '@/routes'
import type { MarqueeEventState } from '@/sdk'

/** Tab that matches the event's lifecycle stage. */
const tabPathForState = (state?: MarqueeEventState): string => {
	if (state === 'live') {
		return routes.MARQUEE_EVENT_CHECK_IN.path
	}
	if (state === 'closed') {
		return routes.MARQUEE_EVENT_EXPORT.path
	}
	return routes.MARQUEE_EVENT_ATTENDEES.path
}

/**
 * Index route for `/marquee/events/:id` — sends the operator straight to the
 * tab that matches the event's state: `live` → Check-in, `closed` → Export,
 * otherwise (`pre_work`) → Attendees. Waits for the detail to load so the
 * decision uses the real state instead of defaulting.
 */
export function MarqueeEventTabRedirect() {
	const { id } = useParams<{ id: string }>()
	const { data: event, isLoading } = useQuery(eventQueryOptions(id))

	if (isLoading) {
		return (
			<div className='flex flex-1 items-center justify-center py-20'>
				<Spinner size={24} />
			</div>
		)
	}

	return <Navigate replace to={tabPathForState(event?.state)} />
}
